import _ from 'lodash';
import moment from 'moment';

class Entity {
  constructor(data) {
    _.merge(this, data);

    this.id = data.id || null;
    if (data) {
      this.created = this.convertDate(data.created);
    }
  }

  convertDate(date) {
    return date ? moment(date) : null;
  }
}

export default Entity;



// WEBPACK FOOTER //
// ./client/domain/entity.js